<template>
  <b-modal v-model="isShow" @hidden="$emit('update:isShow', false)" centered size="md">
    <FormItems
      ref="formRef"
      :disabled="data.Status === 'YES' || isViewOnly"
      :formData.sync="formData"
      :items="formItems"
    />
    <template #modal-header>
      <h4 class="mb-0 text-primary">
        {{ isViewOnly ? $t("ar_client_detail_sms") : $t("ar_client_update_sms") }}
      </h4>
      <div class="d-flex align-items-center">
        <ez-icon
          v-if="isValidPermission(AR_USMS01)"
          icon="ezAr-icon-edit"
          :class="{ 'cursor-pointer': isViewOnly }"
          class="mr-1"
          size="24"
          :color="isViewOnly ? '#ea5455' : '#ccc'"
          @click="isViewOnly = false"
        />
        <ez-icon
          icon="ezAr-icon-x"
          class="cursor-pointer"
          size="24"
          color="#114A9F"
          @click="$emit('update:isShow', false)"
        />
      </div>
    </template>
    <template #modal-footer>
      <b-button v-if="!isViewOnly && data.Status !== 'YES'" @click="updateSMS" variant="primary">{{
        $t("ar_common_save")
      }}</b-button>
      <div v-else></div>
    </template>
  </b-modal>
</template>
<style lang="scss">
.dialog-class {
  width: 726px;
}
</style>
<script>
import FormItems from "../ultils/Form/FormItems.vue";

import {
  defineComponent,
  reactive,
  toRefs,
  watch,
  getCurrentInstance,
  computed,
  ref,
} from "@vue/composition-api";
import { useFetch } from "../ultils/Hooks/useFetch.ts";
import { convertSmsDistributionStatus } from "../ultils/status";
import { arClient } from "@/api/ar-client";
import dayjs from "dayjs";
import { AR_USMS01 } from "@/api/constant";
export default defineComponent({
  name: "ModalSMS",
  props: {
    isShow: Boolean,
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup(props, { refs, emit }) {
    const vm = getCurrentInstance().proxy;
    const formData = ref({});
    const formRef = ref();
    const isViewOnly = ref(true);

    const formItems = computed(() => [
      {
        type: "select",
        name: "ArTravelAgentId",
        dataSource: arClient.api_AR_RCL01,
        dataSourceParams: {
          IsCheckPermission: false,
        },
        required: true,
        label: "ar_client_company",

        placeholder: "ar_client_company",
        customOptions: (options) =>
          options.map((opt) => ({ ...opt, CodeName: `${opt.TravelAgentCode} - ${opt.NameVi}` })),
        labelOption: "CodeName",
      },
      {
        type: "select",
        required: true,
        dataSource: arClient.api_AR_RAA01,
        dataSourceParams: {
          IsCheckPermission: false,
          ArTravelAgentId: formData.value.ArTravelAgentId,
        },
        disabled: !formData.value.ArTravelAgentId,
        label: "ar_client_debit_account",
        customReduce: "AccountCode",
        labelOption: "AccountCode",
        name: "ArAccountCode",
      },
      {
        type: "cleave",
        disabled: true,
        required: true,
        label: "ar_client_amount",
        cleaveType: "currency",
        name: "Amount",
      },

      {
        type: "string",
        disabled: true,
        label: "ar_client_allotment_states",
        name: "Status",
      },
      {
        type: "string",
        disabled: true,
        label: "ar_client_currency_code",
        name: "CurrencyCode",
      },

      {
        disabled: true,
        type: "string",
        label: "ar_client_created_date",
        name: "CreateDate",
      },
      {
        type: "string",
        variant: "textarea",
        label: "ar_client_content",
        name: "Note",
        wrapperClass: "col-12",
      },
    ]);
    const { fetchData } = useFetch(arClient.api_AR_USMS01, {
      showLoading: true,
    });
    const updateSMS = () => {
      formRef.value.validate().then((success) => {
        if (success) {
          const body = formData.value;

          body.Amount = +body.Amount;
          delete body.CreateDate;
          delete body.Status;
          emit("update:isShow", false);
          fetchData({ ArPaymentSMSDetail: body });
          emit("refetch");
        }
      });
    };

    watch(
      () => props.data,
      (value) => {
        if (value.Status === "YES") {
          isViewOnly.value = false;
        }
        formData.value = {
          ...value,
          CreateDate: dayjs(value.CreateDate).format("DD/MM/YYYY"),
          Status: vm.$t(convertSmsDistributionStatus(value.Status).title),
          CurrencyCode: "VND",
        };
      },
      { deep: true }
    );
    watch(
      () => formData.value.ArTravelAgentId,
      (value) => {
        if (!value) {
          formData.value.ArAccountCode = undefined;
        }
      },
      { deep: true }
    );
    watch(
      () => props.isShow,
      (value) => {
        if (!value) {
          isViewOnly.value = true;
        }
      },
      { deep: true }
    );
    return { formRef, formData, formItems, updateSMS, isViewOnly };
  },

  components: {
    FormItems,
  },
});
</script>
